module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-3x2-1a47a2e1038a068a1cd2fd63cf8e3de2.jpg";